import type React from "react";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./ConstructionList.module.scss";

type Props = {
	fee: number;
	feeTitle: string;
	showSwitchEnable: boolean;
};

export const FeeRow: React.FC<Props> = ({
	fee,
	showSwitchEnable,
	feeTitle
}: Props) => (
	<tr className={Styles.ListRow}>
		<td className={Styles.OrderHandle} />
		{showSwitchEnable ? <td className={Styles.SwitchEnable} /> : null}
		<td className={Styles.Estimation}>
			<div className={Styles.Point}>{feeTitle}</div>
		</td>
		<td className={Styles.UnitAmount} />
		<td className={Styles.ChargePer} />
		<td className={Styles.Amount}>¥{toThousandSeparator(fee)}</td>
		<td className={Styles.Buttons} />
	</tr>
);
